import React from 'react';
import {
  StyledPaymentAlert,
  StyledChatLink,
  StyledPaymentText,
} from '../PurchaseLicenseModal.styles';

interface ErrorBannerProps {
  setExpiredPaymentDialogOpen: (expiredPaymentDialogOpen: boolean) => void;
}

const BILLING_URL = `${window.location.origin}/apps/billing/#/landing/payment`;

export const DefaultPaymentMethodDoesNotExistErrorBanner = () => (
  <StyledPaymentAlert severity="error">
    <div>
      It looks like we don&apos;t have a default payment method for you on file.
      To proceed, please add a{' '}
      <StyledChatLink
        href={BILLING_URL}
        target="_self"
        data-testid="PlatformAdminUI-PurchaseLicenseModal-BillingLink"
      >
        payment method
      </StyledChatLink>
      .
    </div>
  </StyledPaymentAlert>
);

export const LicensePriceNotValidErrorBanner = () => (
  <StyledPaymentAlert severity="error">
    This license cannot be purchased. Please select another license or contact
    your manager for more help.
  </StyledPaymentAlert>
);

export const InvalidBillingInfoErrorBanner = () => (
  <StyledPaymentAlert severity="error">
    <div>
      We are unable to process your transaction at this time. Please contact
      your account manager or{' '}
      <StyledChatLink
        href="https://www.nextiva.com/support/"
        target="_blank"
        data-testid="PlatformAdminUI-PurchaseLicenseModalChatLink"
      >
        chat with us
      </StyledChatLink>
      .
    </div>
  </StyledPaymentAlert>
);

export const PaymentMethodNotSupportedErrorBanner = () => (
  <StyledPaymentAlert severity="error">
    <div>
      We don&apos;t currently support the payment method you have on file. To
      proceed, you have the option to add an alternative{' '}
      <StyledChatLink
        href={BILLING_URL}
        target="_self"
        data-testid="PlatformAdminUI-PurchaseLicenseModal-BillingLink"
      >
        form of payment
      </StyledChatLink>
      .
    </div>
  </StyledPaymentAlert>
);

export const ExpiredPaymentErrorBanner = ({
  setExpiredPaymentDialogOpen,
}: ErrorBannerProps) => (
  <StyledPaymentAlert severity="error">
    Your form of payment has expired. Please add a new&nbsp;
    <StyledPaymentText
      onClick={() => setExpiredPaymentDialogOpen(true)}
      data-testid="PlatformAdminUI-PurchaseLicenseModal-ExpiredPaymentText"
    >
      form of payment
    </StyledPaymentText>
    .
  </StyledPaymentAlert>
);

export const DeclinedPaymentErrorBanner = ({
  setExpiredPaymentDialogOpen,
}: ErrorBannerProps) => (
  <StyledPaymentAlert severity="error">
    Your form of payment has been declined. You can try again or verify
    your&nbsp;
    <StyledPaymentText
      onClick={() => setExpiredPaymentDialogOpen(true)}
      data-testid="PlatformAdminUI-PurchaseLicenseModalDeclinedPaymentText"
    >
      form of payment
    </StyledPaymentText>
    .
  </StyledPaymentAlert>
);

export const GeneralErrorBanner = () => (
  <StyledPaymentAlert severity="error">
    <div>
      We are unable to process your transaction at this time. Please try again
      in a couple of minutes or{' '}
      <StyledChatLink
        href="https://www.nextiva.com/support/"
        target="_blank"
        data-testid="PlatformAdminUI-PurchaseLicenseModalChatLink"
      >
        chat with us
      </StyledChatLink>{' '}
      if the problem persists.
    </div>
  </StyledPaymentAlert>
);
